<script lang="ts">
	export let label: string,
		value: number | null,
		type: 'g.' | 'cm.' = 'cm.';
</script>

{#if value}
	<div class="flex flex-col items-center">
		<small class="opacity-80">{label}</small>
		<span>{value} {type}</span>
	</div>
{/if}
